import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackIntegrationPageAddLinkEvent = createAnalyticsTracker(
  'integrationPageAddLink',
);
